import { render, staticRenderFns } from "./listApplyRoomDiscountRecordDetailsList.vue?vue&type=template&id=21565f6e&scoped=true"
import script from "./listApplyRoomDiscountRecordDetailsList.vue?vue&type=script&lang=js"
export * from "./listApplyRoomDiscountRecordDetailsList.vue?vue&type=script&lang=js"
import style0 from "./listApplyRoomDiscountRecordDetailsList.vue?vue&type=style&index=0&id=21565f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21565f6e",
  null
  
)

export default component.exports